import { styled } from "styled-components";

const FormWrapper = styled.div`
    width: 80%;
    margin: auto;
    margin-top: 2rem;
    border: 1px solid #F0F0F0;
    border-radius: 0.5rem;
    animation: slide-down 300ms ease-out forwards;

    form {
        width: 65%;
        margin: auto;
    }
    .control {
        display: flex;
        align-items: center;
        justify-content: end;
        gap: 3rem;
        margin-bottom: 3rem;
    }
    .control label {
        width: 30%;
        font-weight: bold;
        font-size: 1.5rem;
        letter-spacing: 0.0625rem;
        color: #36454F;
    }
    .ant-input {
        border-radius: 0.2rem;
    }
    .ant-input:focus {
        border-color: ${({theme}) => theme.colors.primary};
    }
    .ant-input-password {
        border-radius: 0.2rem;
    }
    .ant-select .ant-select-selector {
        border-radius: 0.2rem;
    }
`;

export default FormWrapper;